import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";
import { ThirdPartyOnDemandReportLayerType } from "../layer_types/ThirdPartyOnDemandReportLayerType/ThirdPartyOnDemandReportLayerType";
import { ThirdPartyOnDemandLayerType } from "../layer_types/ThirdPartyOnDemandReportLayerType/ThirdPartyOnDemandLayerType";

export const SPATIAL_RISK_MULTIPLIERS: Layer = {
  id: ConstraintsCategory.SPATIAL_RISK_MULTIPLIERS,
  layerType: ConstraintsLayerType,
  title: "BNG spatial risk multipliers",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-shield-check-line",
  description:
    "Offsite mitigation for BNG will be more expensive for sites outside the development site's spatial risk multiplier areas",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.SPATIAL_RISK_MULTIPLIERS,
    categorySchema: [
      { key: "national_character_areas" },
      { key: "operational_catchments" },
      { key: "waterbody_catchments" },
      { key: "open_rivers" },
    ],
  },
};

export const AIDASH_LAYER: ThirdPartyOnDemandLayerType = {
  id: "aidash-on-demand-report-layer",
  layerType: ThirdPartyOnDemandReportLayerType,
  title: "AI Dash",
  toggleable: true,
  description: "Purchase BNG reports",
  layerConfig: {
    providerName: "aidash",
  },
};
